import { SITE_INTEGRATION_TYPE } from "@shared/common/constant/site";
import { integrationTypeStringToEnum } from "@shared/common/utils/integrations";
import { getCookie } from "cookies-next";

const getIntegrationType = (): SITE_INTEGRATION_TYPE | null => {
  const value = getCookie("cnb_i_type");
  if (!value) {
    return null;
  }
  return integrationTypeStringToEnum(value);
};

export default getIntegrationType;
